import { useCallback, useEffect, useState } from 'react';
import {
  getCompletedOnboardingSteps,
  type OnboardingStepId,
} from '@/services/onboardingProgress';
import { ONBOARDING_PROGRESS_CHANGED_EVENT } from '@/utils/constants';

export function useOnboardingProgress() {
  const [completedSteps, setCompletedSteps] = useState<OnboardingStepId[]>(
    getCompletedOnboardingSteps
  );

  useEffect(() => {
    const refresh = () => setCompletedSteps(getCompletedOnboardingSteps());
    window.addEventListener(ONBOARDING_PROGRESS_CHANGED_EVENT, refresh);
    return () => window.removeEventListener(ONBOARDING_PROGRESS_CHANGED_EVENT, refresh);
  }, []);

  const completedCount = completedSteps.length;

  const isStepComplete = useCallback(
    (stepId: string) => completedSteps.includes(stepId as OnboardingStepId),
    [completedSteps]
  );

  return { completedSteps, completedCount, isStepComplete };
}
